import React from 'react';

import Tag from '@atlaskit/tag';

export default (): React.JSX.Element => (
	<Tag text="Removable tag link" removeButtonLabel="Remove" href="/components/tag" />
);
